import { jsx as o, jsxs as p } from "react/jsx-runtime";
import { Root as g, Slottable as v } from "@radix-ui/react-slot";
import { cva as n } from "class-variance-authority";
import { forwardRef as y } from "react";
import { cn as r } from "../../../utils/utils.mjs";
const b = n(
  "p-3 flex items-center justify-center rounded-capsule outline-offset-2 focus:outline-blue-600 hover:cursor-pointer",
  {
    variants: {
      variant: {
        secondary: "bg-gray-800 hover:bg-gray-900 text-gray-200",
        transparent: "bg-transparent text-gray-900"
      },
      size: {
        small: "size-8 p-2.5",
        default: "size-10",
        large: "size-14"
      },
      disabled: {
        true: "bg-gray-200 text-gray-500 focus:outline-none hover:bg-gray-200 hover:text-gray-500 hover:cursor-not-allowed"
      }
    }
  }
), h = n("fill-current hover:fill-current", {
  variants: {
    size: {
      small: "size-3",
      default: "size-4",
      large: "size-4"
    }
  }
}), x = y(
  ({
    className: a = "",
    children: s,
    variant: i = "secondary",
    size: t = "default",
    disabled: e = !1,
    icon: c,
    asChild: l,
    ...u
  }, m) => {
    const f = r(b({ variant: i, size: t, disabled: e }), a), d = /* @__PURE__ */ o("div", { "data-testid": "icon-button-icon-container", className: r(h({ size: t })), children: c });
    return /* @__PURE__ */ p(
      l ? g : "button",
      {
        "data-testid": "icon-button",
        title: "Icon button",
        className: f,
        disabled: e,
        ...u,
        ref: m,
        children: [
          /* @__PURE__ */ o(v, { children: s }),
          d
        ]
      }
    );
  }
);
x.displayName = "IconButton";
export {
  x as IconButton
};
